export default "__VITE_ASSET__DCpEevvu__"